import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import SkeletonReRegistrationList from "../../loaders/SkeletonReRegistrationList";
import { GetReRegistrationList } from "../../services/ReRegistrationService";
import { setReRegistrations } from "../../store/actions";
import ReRegistrationList from "./ReRegistrationList";

function ReRegistration(props) {
  const isMounted = useRef(true);
  const [reRegistrationList, SetReRegistrationList] = useState([]);
  const [loading, setloading] = useState(false);
  // const user = useSelector(state=>state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    isMounted.current = true;
    GetReRegistrationList().then((res) => {
      if (isMounted.current) {
        setloading(true);
        SetReRegistrationList(res.data);
        dispatch(setReRegistrations(res.data))
      }
    });
    // if(props.id === undefined || props.id === ""){
    //   GetUpdateNotificationReregRead({uId:user.id})
    //   .then(res => {
    //     console.log("resssssss",res);
    //     GetMyUnreadNotificationCount({is_reg_registration:1})
    //       .then(res=>{
    //         // console.log("count res-------------------------",res.data);
    //         dispatch(setReRegistraionCount(res.data.notificationsCount.unreadNotificationCount ? res.data.notificationsCount.unreadNotificationCount: 0));
    //         // dispatch(setUnreadNotificationCount(res.data.notificationsCount.unreadNotificationCount));
    //       })
    //       .catch(error=>{
    //         console.error(error);
    //       })
    //   })
    //   .catch(error=>{
    //     console.error(error);
    //   });
    // }
    return () => {
      isMounted.current = false;
    }


  }, [props.id]);

  return (
    <>
      {!loading && <div className="re-registration-list-wrap">
        <div className="my-tickets-heading-blk flex-direction mb-4">
          <h4 className="text-left-align landing-heading heading_color_dynamic">My <span>Applications</span></h4>
          <div className="text-md-right"><p className=""></p></div>
        </div>

        <ul className="re-registration-ul-list list-unstyled">
          <SkeletonReRegistrationList />
        </ul>
      </div>}
      {loading && <div className="re-registration-list-wrap">
        <h4 className="my-md-2 my-0 landing-heading">
          My <span>Applications</span>
        </h4>
        <ul className="re-registration-ul-list list-unstyled">
          {/* only show the tabs which has show key equal to 1 in open array */}
          {reRegistrationList && reRegistrationList.open ? (
            props.id !== undefined
              ? reRegistrationList.open.filter(item => item.id === Number(props.id))?.filter(item => item?.show == 1).map((registration, index) => {
                return <ReRegistrationList registration={registration} key={index} />;
              })
              : reRegistrationList.open?.filter(item => item?.show == 1).map((registration, index) => {
                // if(registration.reRegistrationStatus !== "Declined"){
                return <ReRegistrationList registration={registration} key={index} />;
                // }
              })
          ) : (
            <SkeletonReRegistrationList />
          )}
        </ul>

        {/* Show Completed */}
        {reRegistrationList?.close?.length > 0 ? (
          <>
            <button
              data-toggle="collapse"
              data-target="#completed-exam"
              aria-expanded="false"
              className="collapsed hide-completed"
            ></button>
            <div
              className="re-registration-completed-list collapse"
              id="completed-exam"
            >
              <ul className="re-registration-ul-list list-unstyled">
                {/* {card should be not clickable if the registration is closed not registered}****************************** disabled prop is for this pur only********* */}
                {reRegistrationList.close.filter(item => item?.show == 1).map((registration, index) => {
                  return <ReRegistrationList registration={registration} disabled={!(registration.registrationStatus || registration.per)} key={index} />;
                })
                }
              </ul>
            </div>
          </>
        ) : null}
      </div>}
    </>
  );
}

export default ReRegistration;
